import { useEffect, useState } from 'react';

import { useApi } from '#/api/fetch-api';
import { Dashboard, getAuthenticatedMetabaseUrl } from '#/api/metabase';
import { useWalletView } from '#/features/wallet/wallet-context';

interface Store {
  readonly status: 'loading' | 'done' | 'error';
  readonly error: string;
  readonly url: string | null;
}

const INITIAL_STATE: Store = {
  status: 'done',
  error: '',
  url: null,
};

interface Params {
  readonly dashboard: Dashboard;
}

export default function useAuthenticatedMetabaseUrl(params: Params) {
  const { dashboard } = params;
  const [state, setState] = useState<Store>(INITIAL_STATE);
  const [, exec] = useApi(getAuthenticatedMetabaseUrl);
  const walletView = useWalletView();

  const isReady = walletView.isSignedIn;

  useEffect(() => {
    if (!isReady) return;
    setState((prev) => ({ ...prev, status: 'loading', error: '' }));
    exec({ dashboard }, (result) => {
      if (result.ok) {
        setState((prev) => ({
          ...prev,
          status: 'done',
          url: result.data.dashboard_url,
        }));
      } else {
        setState((prev) => ({
          ...prev,
          status: 'error',
          error: result.message,
        }));
      }
    });
  }, [dashboard, exec, isReady, setState]);

  return state;
}
